module.exports = __webpack_public_path__ + "static/media/AgendaTelefonica.523bf4c5.jpg";